import { useContext } from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFacebookSquare, faLinkedin} from "@fortawesome/free-brands-svg-icons";
import { UserContext } from "../partials/Context";

function SocialLinks() {
    const user = useContext(UserContext)
    const {is_authenticated} = user || '';

    let facebook_link ='';
    let year = new Date().toLocaleDateString().slice(5,10);

    if(is_authenticated) {
        facebook_link = 'https://www.facebook.com/Marketing.Prawnika/'
    } else {
        facebook_link = 'https://www.facebook.com/specprawnik';
    }

    return (
        <div id="social-links" className="col-sm-3 social-links">
            <div>
                <a href={facebook_link} target="_blank" rel="noreferrer">
                    <FontAwesomeIcon icon={faFacebookSquare} className="fa-2x fa-facebook"/>
                </a>
            </div>
                <a href='https://www.linkedin.com/company/specprawnik' target="_blank" rel="noreferrer">
                    <FontAwesomeIcon icon={faLinkedin} className="fa-2x"/>
                </a>
            <div className="blogger">
                <a href={'/marketing-dla-prawnika/'}target="_blank" rel="noreferrer">
                    <img src='/media/img/icons/Blogger.png' alt="ikona bloga"/>
                </a>
            </div>
            <div className="copyrights">
                Copyright &copy; 2013 - {year}
                <b> specprawnik.pl</b><br/>
                <span className="secondaryInfo">All Rights Reserved. Wszelkie prawa zastrzeżone.</span>
            </div>
        </div>
    )
}

export default SocialLinks;